import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAssessmentResults } from '../hooks/useAssessmentResults/useAssessmentResults';
import { LoadingState, ErrorState } from './AssessmentResults/LoadingStates';
import { AssessmentResultsHeader } from './AssessmentResults/AssessmentResultsHeader';
import { AssessmentResultsTabs } from './AssessmentResults/AssessmentResultsTabs';
import { ExecutiveSummaryTab } from './AssessmentResults/Tabs/ExecutiveSummaryTab';
import { PriorityOpportunitiesTab } from './AssessmentResults/Tabs/PriorityOpportunitiesTab';
import { ImplementationGuideTab } from './AssessmentResults/Tabs/ImplementationGuideTab';
import { BenchmarksTab } from './AssessmentResults/Tabs/BenchmarksTab';
import { RoadmapTab } from './AssessmentResults/Tabs/RoadmapTab';

const EnhancedAssessmentResults = () => {
  const { assessmentId } = useParams();
  const navigate = useNavigate();
  
  const {
    assessment,
    recommendations,
    benchmarkData,
    loading,
    error,
    activeTab,
    setActiveTab,
    isUser
  } = useAssessmentResults(assessmentId);

  const handleUpgradeToFull = () => {
    navigate('/esa-report-purchase', {
      state: {
        assessmentId,
        facilityName: assessment?.facility_name,
        industry: assessment?.industry_name
      }
    });
  };

  // Improves perceived performance during backend analysis and report generation (typically 2-5 seconds)
  if (loading) {
    return <LoadingState />;
  }

  if (error) {
    return <ErrorState error={error} />;
  }

  const tabConfig = [
    { id: 'executive-summary', label: 'Executive Summary', icon: '📊' },
    { id: 'priority-opportunities', label: 'Priority Opportunities', icon: '🎯' },
    { id: 'implementation-guide', label: 'Implementation Guide', icon: '📋' },
    { id: 'benchmarks', label: 'Benchmarks', icon: '📈' },
    { id: 'roadmap', label: 'Implementation Roadmap', icon: '🗺️' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'executive-summary':
        return <ExecutiveSummaryTab assessment={assessment} recommendations={recommendations} />;
      case 'priority-opportunities':
        return <PriorityOpportunitiesTab recommendations={recommendations} />;
      case 'implementation-guide':
        return <ImplementationGuideTab recommendations={recommendations} />;
      case 'benchmarks':
        return <BenchmarksTab benchmarks={benchmarkData} />;
      case 'roadmap':
        return <RoadmapTab recommendations={recommendations} />;
      default:
        return <ExecutiveSummaryTab assessment={assessment} recommendations={recommendations} />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-slate-800">
      <AssessmentResultsHeader
        assessment={assessment}
        assessmentId={assessmentId}
        isUser={isUser}
      />

      <AssessmentResultsTabs
        tabs={tabConfig}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />

      <div className="max-w-7xl mx-auto px-4 py-8">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default EnhancedAssessmentResults;
